import React from 'react';
import Layout from '../../components/Layout/Layout';

function About() {
	return (
		<Layout title='About'>
			<div className='cart-page container-fluid container-min-max-width'>
				<h1>About</h1>
			</div>
		</Layout>
	);
}

export default About;
